const Reflux = require("reflux");
const ScheduledTasksActions = require("../actions/scheduled-tasks-actions");

const ScheduledTasksStore = Reflux.createStore({
  state: {
    loading: true,
    failed: false,
    data: []
  },

  init: function() {
    this.listenTo(ScheduledTasksActions.fetchData, this.onFetchStarted);
    this.listenTo(ScheduledTasksActions.fetchData.completed, this.onFetchCompleted);
    this.listenTo(ScheduledTasksActions.fetchData.failed, this.onFetchFailed);

    this.state = this.getInitialState();
  },

  getInitialState: function() {
    return this.state;
  },

  onFetchStarted: function() {
    this.state = {
      loading: true,
      failed: false
    };

    this.trigger(this.state);
  },

  onFetchCompleted: function(data) {
    this.state = {
      loading: false,
      data: data.data
    };

    this.trigger(this.state);
  },

  onFetchFailed: function(error) {
    this.state = {
      loading: false,
      failed: true
    };

    this.trigger(this.state);
  }
});

module.exports = ScheduledTasksStore;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/stores/scheduled-tasks-store.js